import { c as _c } from "react/compiler-runtime";
import { MoreHoriz } from "@website/icons/components/more-horiz";
import { MaterialIcon } from "@website/icons/material";
import { USER_TRACKING_EVENTS } from "@website/tracking/tracking.types";
import { addEventToTracking } from "@website/tracking/user";
import { Button } from "@website/ui/button";
import { FALLBACK_IMAGE_MD, LazyImage } from "@website/ui/lazy-image";
import { Modal } from "@website/ui/modal";
import { openBrowser } from "@website/widget/scripts/igp";
import { useState } from "react";
import type { VillaShareTarget } from "./villa-share.utils";
import { getVillaShareTargets } from "./villa-share.utils";
export type VillaShareProperties = {
  address?: string;
  image?: string;
  shareUrl: string;
  title: string;
  villaId: number;
};
type CopyStatus = "idle" | "copied" | "error";
const WhatsappIcon = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path fillRule="evenodd" clipRule="evenodd" d="M19.9599 4.00809C17.8549 1.90063 15.0555 0.739517 12.0731 0.738281C5.9276 0.738281 0.926071 5.73967 0.923599 11.8868C0.922775 13.8518 1.43611 15.7701 2.41183 17.4608L0.830078 23.2383L6.74059 21.6878C8.36917 22.5762 10.2027 23.0444 12.0685 23.0449H12.0732C18.218 23.0449 23.2201 18.0431 23.2224 11.8957C23.2236 8.9165 22.065 6.1154 19.9599 4.00809ZM12.0731 21.162H12.0692C10.4064 21.1613 8.77567 20.7144 7.35266 19.8703L7.01442 19.6694L3.50703 20.5895L4.44321 17.1698L4.22279 16.8192C3.29514 15.3438 2.80528 13.6384 2.80611 11.8875C2.80803 6.77815 6.96526 2.62134 12.0768 2.62134C14.552 2.62216 16.8788 3.58731 18.6283 5.33894C20.3779 7.09058 21.3409 9.41885 21.34 11.895C21.3378 17.0048 17.1809 21.162 12.0731 21.162ZM17.1562 14.2215C16.8777 14.082 15.5079 13.4083 15.2525 13.3152C14.9974 13.2222 14.8114 13.1759 14.6259 13.4547C14.4401 13.7335 13.9063 14.3611 13.7437 14.5469C13.5811 14.7328 13.4188 14.7561 13.1401 14.6166C12.8615 14.4772 11.9639 14.1829 10.8997 13.2339C10.0716 12.4952 9.51257 11.5829 9.34998 11.3041C9.18765 11.0251 9.3486 10.8888 9.4722 10.7356C9.77377 10.3611 10.0758 9.96844 10.1686 9.78264C10.2616 9.59669 10.215 9.43396 10.1452 9.29457C10.0758 9.15518 9.51862 7.78395 9.28653 7.22598C9.06021 6.68298 8.83073 6.75632 8.65962 6.7478C8.4973 6.7397 8.31149 6.73805 8.12569 6.73805C7.94002 6.73805 7.63817 6.80768 7.38274 7.08673C7.12744 7.36565 6.40784 8.03952 6.40784 9.41075C6.40784 10.782 7.40608 12.1067 7.54533 12.2926C7.68459 12.4785 9.50983 15.2924 12.3043 16.499C12.969 16.7863 13.4878 16.9575 13.8925 17.0859C14.56 17.298 15.1671 17.268 15.6472 17.1964C16.1825 17.1163 17.2953 16.5223 17.5276 15.8717C17.7597 15.2209 17.7597 14.6632 17.69 14.5469C17.6205 14.4307 17.4347 14.3611 17.1562 14.2215Z" fill="#44D980" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
const TelegramIcon = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g clipPath="url(#clip0_9686_282073)"><path d="M21.943 5.12705L18.9249 19.3605C18.6972 20.365 18.1034 20.615 17.2596 20.1418L12.6609 16.7531L10.442 18.8872C10.1964 19.1328 9.99105 19.3381 9.5178 19.3381L9.84818 14.6547L18.3713 6.9531C18.7418 6.62272 18.2909 6.43966 17.7953 6.77005L7.25867 13.4046L2.72255 11.9848C1.73585 11.6767 1.718 10.9981 2.92792 10.5248L20.6706 3.68942C21.4921 3.38135 22.2109 3.87247 21.943 5.12705Z" fill="#00B1EA" /></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <svg width="24" height="24" viewBox="0 0 24 24" fill="none">{t0}<defs><clipPath id="clip0_9686_282073"><rect width="24" height="24" fill="white" /></clipPath></defs></svg>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
const XIcon = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M13.6769 10.6453L20.237 3.1875H18.6825L12.9863 9.66303L8.43678 3.1875H3.18945L10.0692 12.9797L3.18945 20.8003H4.74409L10.7594 13.962L15.564 20.8003H20.8113L13.6765 10.6453H13.6769ZM11.5476 13.0659L10.8505 12.0908L5.30424 4.33205H7.69207L12.168 10.5936L12.865 11.5687L18.6832 19.7078H16.2954L11.5476 13.0663V13.0659Z" fill="#040A1F" fillOpacity="0.87" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
const ShareTargetIcon = t0 => {
  const $ = _c(5);
  const {
    icon
  } = t0;
  if (icon === "whatsapp") {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <WhatsappIcon />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  if (icon === "telegram") {
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <TelegramIcon />;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  if (icon === "x") {
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <XIcon />;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    return t1;
  }
  const t1 = icon === "email" ? "mail_outline" : icon;
  let t2;
  if ($[3] !== t1) {
    t2 = <MaterialIcon name={t1} variant="outlined" />;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
const copyShareUrl = async (shareUrl: string) => {
  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(shareUrl);
    return;
  }
  const textArea = document.createElement("textarea");
  textArea.value = shareUrl;
  textArea.style.position = "fixed";
  textArea.style.opacity = "0";
  textArea.style.bottom = "100%";
  document.body.append(textArea);
  textArea.select();
  const copied = document.execCommand("copy");
  textArea.remove();
  if (!copied) {
    throw new Error("Copying the villa URL failed");
  }
};
const supportsNativeShare = (shareData: ShareData) => {
  if (typeof navigator === "undefined" || typeof navigator.share !== "function") {
    return false;
  }
  try {
    return typeof navigator.canShare !== "function" || navigator.canShare(shareData);
  } catch {
    return false;
  }
};
export const VillaShare = t0 => {
  const $ = _c(86);
  const {
    address,
    image,
    shareUrl,
    title,
    villaId
  } = t0;
  const [isOpen, setIsOpen] = useState(false);
  const [canNativeShare, setCanNativeShare] = useState(false);
  const [copyStatus, setCopyStatus] = useState("idle");
  let T0;
  let handleCopy;
  let t1;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t15;
  let t16;
  let t17;
  let t18;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== address || $[1] !== canNativeShare || $[2] !== image || $[3] !== isOpen || $[4] !== shareUrl || $[5] !== title || $[6] !== villaId) {
    const shareTargets = getVillaShareTargets(title, shareUrl);
    const shareData = {
      text: title,
      title,
      url: shareUrl
    };
    const trackingProperties = {
      product: "villa" as const,
      property_id: Number(villaId) as any,
      property_name: title
    };
    const openModal = () => {
      addEventToTracking(USER_TRACKING_EVENTS.VILLA_SHARE_CLICKED, trackingProperties);
      setCanNativeShare(supportsNativeShare(shareData));
      setIsOpen(true);
    };
    const closeModal = () => {
      addEventToTracking(USER_TRACKING_EVENTS.VILLA_SHARE_MODAL_CLOSED, trackingProperties);
      setIsOpen(false);
      setCanNativeShare(false);
      setCopyStatus("idle");
    };
    const handleShareTargetClick = (href, shareChannel) => {
      addEventToTracking(USER_TRACKING_EVENTS.VILLA_SHARE_CHANNEL_CLICKED, {
        ...trackingProperties,
        share_channel: shareChannel
      });
      openBrowser(href, "_blank");
    };
    const handleNativeShare = async () => {
      if (!supportsNativeShare(shareData)) {
        return;
      }
      addEventToTracking(USER_TRACKING_EVENTS.VILLA_SHARE_CHANNEL_CLICKED, {
        ...trackingProperties,
        share_channel: "more"
      });
      try {
        await navigator.share(shareData);
      } catch {}
    };
    handleCopy = async () => {
      try {
        await copyShareUrl(shareUrl);
        addEventToTracking(USER_TRACKING_EVENTS.VILLA_SHARE_LINK_COPIED, trackingProperties);
        setCopyStatus("copied");
        setTimeout(() => setCopyStatus("idle"), 3000);
      } catch {
        setCopyStatus("error");
      }
    };
    let t19;
    if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
      t19 = <MaterialIcon name="share" variant="outlined" />;
      $[27] = t19;
    } else {
      t19 = $[27];
    }
    t17 = <Button aria-label={"\u0627\u0634\u062A\u0631\u0627\u06A9 \u06AF\u0630\u0627\u0631\u06CC \u0627\u06CC\u0646 \u0648\u06CC\u0644\u0627"} className="!hidden md:!flex" color="neutral" onClick={openModal} size="small" StartIcon={t19} variant="text">اشتراک گذاری</Button>;
    let t20;
    if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
      t20 = <MaterialIcon name="share" variant="outlined" />;
      $[28] = t20;
    } else {
      t20 = $[28];
    }
    if ($[29] !== openModal) {
      t18 = <Button aria-label={"\u0627\u0634\u062A\u0631\u0627\u06A9 \u06AF\u0630\u0627\u0631\u06CC \u0627\u06CC\u0646 \u0648\u06CC\u0644\u0627"} className="!absolute left-4 top-4 z-10 !flex !bg-white shadow md:!hidden" color="transparent" equalDimension={true} onClick={openModal} StartIcon={t20} />;
      $[29] = openModal;
      $[30] = t18;
    } else {
      t18 = $[30];
    }
    T0 = Modal;
    t8 = "bottom";
    t9 = "lg:!w-[460px]";
    t10 = "auto";
    t11 = closeModal;
    t12 = isOpen;
    t13 = true;
    t14 = "!text-[24px] !text-on-surface-medium-emphasis";
    t15 = "\u0627\u0634\u062A\u0631\u0627\u06A9 \u06AF\u0630\u0627\u0631\u06CC \u0627\u06CC\u0646 \u0648\u06CC\u0644\u0627";
    t16 = "!text-headline-6 !font-[500]";
    t5 = "mt-6 flex flex-col gap-4";
    t6 = "rtl";
    let t21;
    if ($[31] !== image || $[32] !== title) {
      t21 = <LazyImage alt={title} className="!h-[55px] !w-[66px] shrink-0 rounded-xl md:!h-[83px] md:!w-[100px]" fallback={FALLBACK_IMAGE_MD.src} height={83} src={image} width={100} />;
      $[31] = image;
      $[32] = title;
      $[33] = t21;
    } else {
      t21 = $[33];
    }
    let t22;
    if ($[34] !== title) {
      t22 = <button aria-label={title} className="text-body-2 line-clamp-2 cursor-pointer border-0 bg-transparent p-0 text-right !font-[700]" type="button">{title}</button>;
      $[34] = title;
      $[35] = t22;
    } else {
      t22 = $[35];
    }
    let t23;
    if ($[36] !== address) {
      t23 = address ? <div className="text-on-surface-medium-emphasis text-caption mt-2 flex items-center gap-1"><MaterialIcon name="location_on" className="text-[16px]" variant="outlined" /><span className="text-extra-caption truncate !font-[400]">{address}</span></div> : null;
      $[36] = address;
      $[37] = t23;
    } else {
      t23 = $[37];
    }
    let t24;
    if ($[38] !== t22 || $[39] !== t23) {
      t24 = <div className="min-w-0 flex-1">{t22}{t23}</div>;
      $[38] = t22;
      $[39] = t23;
      $[40] = t24;
    } else {
      t24 = $[40];
    }
    if ($[41] !== t21 || $[42] !== t24) {
      t7 = <div className="flex items-start gap-3">{t21}{t24}</div>;
      $[41] = t21;
      $[42] = t24;
      $[43] = t7;
    } else {
      t7 = $[43];
    }
    t4 = "";
    t1 = `grid gap-2 ${canNativeShare ? "grid-cols-5" : "grid-cols-4"}`;
    t2 = canNativeShare ? <button aria-label={"\u06AF\u0632\u06CC\u0646\u0647\u200C\u0647\u0627\u06CC \u0628\u06CC\u0634\u062A\u0631 \u0628\u0631\u0627\u06CC \u0627\u0634\u062A\u0631\u0627\u06A9 \u06AF\u0630\u0627\u0631\u06CC"} className="text-caption text-on-surface-high-emphasis flex min-w-0 cursor-pointer flex-col items-center gap-2 border-0 bg-transparent p-0" onClick={() => handleNativeShare()} type="button"><span className="flex size-14 items-center justify-center rounded-full bg-[#F8F9FD] text-2xl hover:bg-[#EBECF2] lg:size-14"><MoreHoriz className="fill-on-surface-medium-emphasis size-6" /></span><span className="text-extra-caption truncate font-normal">بیشتر</span></button> : null;
    t3 = shareTargets.map(t25 => {
      const {
        href: href_0,
        icon,
        label
      } = t25;
      return <button aria-label={`اشتراک گذاری با ${label}`} className="text-caption text-on-surface-high-emphasis flex min-w-0 cursor-pointer flex-col items-center gap-2 border-0 bg-transparent p-0" key={icon} onClick={() => handleShareTargetClick(href_0, icon)} type="button"><span className={`flex size-14 items-center justify-center rounded-full bg-[#F8F9FD] text-2xl hover:bg-[#EBECF2] lg:size-14 ${icon === "whatsapp" || icon === "sms" ? "text-[#44D980]" : icon === "telegram" ? "text-[#00B1EA]" : "text-on-surface-high-emphasis"}`}><ShareTargetIcon icon={icon} /></span><span className="text-extra-caption truncate font-normal">{label}</span></button>;
    });
    $[0] = address;
    $[1] = canNativeShare;
    $[2] = image;
    $[3] = isOpen;
    $[4] = shareUrl;
    $[5] = title;
    $[6] = villaId;
    $[7] = T0;
    $[8] = handleCopy;
    $[9] = t1;
    $[10] = t10;
    $[11] = t11;
    $[12] = t12;
    $[13] = t13;
    $[14] = t14;
    $[15] = t15;
    $[16] = t16;
    $[17] = t17;
    $[18] = t18;
    $[19] = t2;
    $[20] = t3;
    $[21] = t4;
    $[22] = t5;
    $[23] = t6;
    $[24] = t7;
    $[25] = t8;
    $[26] = t9;
  } else {
    T0 = $[7];
    handleCopy = $[8];
    t1 = $[9];
    t10 = $[10];
    t11 = $[11];
    t12 = $[12];
    t13 = $[13];
    t14 = $[14];
    t15 = $[15];
    t16 = $[16];
    t17 = $[17];
    t18 = $[18];
    t2 = $[19];
    t3 = $[20];
    t4 = $[21];
    t5 = $[22];
    t6 = $[23];
    t7 = $[24];
    t8 = $[25];
    t9 = $[26];
  }
  let t19;
  if ($[44] !== t1 || $[45] !== t2 || $[46] !== t3) {
    t19 = <div className={t1}>{t2}{t3}</div>;
    $[44] = t1;
    $[45] = t2;
    $[46] = t3;
    $[47] = t19;
  } else {
    t19 = $[47];
  }
  let t20;
  if ($[48] !== t19 || $[49] !== t4) {
    t20 = <div className={t4}>{t19}</div>;
    $[48] = t19;
    $[49] = t4;
    $[50] = t20;
  } else {
    t20 = $[50];
  }
  let t21;
  if ($[51] !== shareUrl) {
    t21 = <span className="text-body-2 min-w-0 flex-1 truncate text-left" dir="ltr" title={shareUrl}>{shareUrl}</span>;
    $[51] = shareUrl;
    $[52] = t21;
  } else {
    t21 = $[52];
  }
  const t22 = copyStatus === "copied" ? "\u06A9\u067E\u06CC \u0634\u062F!" : "\u06A9\u067E\u06CC \u0644\u06CC\u0646\u06A9";
  let t23;
  if ($[53] !== handleCopy || $[54] !== t22) {
    t23 = <Button aria-label={"\u06A9\u067E\u06CC \u0644\u06CC\u0646\u06A9 \u0627\u0642\u0627\u0645\u062A\u06AF\u0627\u0647"} onClick={handleCopy} color="secondary">{t22}</Button>;
    $[53] = handleCopy;
    $[54] = t22;
    $[55] = t23;
  } else {
    t23 = $[55];
  }
  let t24;
  if ($[56] !== t21 || $[57] !== t23) {
    t24 = <div className="border-outline-thin flex items-center gap-2 rounded-lg border p-2">{t21}{t23}</div>;
    $[56] = t21;
    $[57] = t23;
    $[58] = t24;
  } else {
    t24 = $[58];
  }
  let t25;
  if ($[59] !== copyStatus) {
    t25 = copyStatus === "error" ? <p className="text-error text-caption" role="alert">کپی لینک انجام نشد. لطفا دوباره تلاش کنید.</p> : null;
    $[59] = copyStatus;
    $[60] = t25;
  } else {
    t25 = $[60];
  }
  let t26;
  if ($[61] !== t24 || $[62] !== t25) {
    t26 = <div className="flex flex-col gap-2">{t24}{t25}</div>;
    $[61] = t24;
    $[62] = t25;
    $[63] = t26;
  } else {
    t26 = $[63];
  }
  let t27;
  if ($[64] !== t20 || $[65] !== t26 || $[66] !== t5 || $[67] !== t6 || $[68] !== t7) {
    t27 = <div className={t5} dir={t6}>{t7}{t20}{t26}</div>;
    $[64] = t20;
    $[65] = t26;
    $[66] = t5;
    $[67] = t6;
    $[68] = t7;
    $[69] = t27;
  } else {
    t27 = $[69];
  }
  let t28;
  if ($[70] !== T0 || $[71] !== t10 || $[72] !== t11 || $[73] !== t12 || $[74] !== t13 || $[75] !== t14 || $[76] !== t15 || $[77] !== t16 || $[78] !== t27 || $[79] !== t8 || $[80] !== t9) {
    t28 = <T0 animate={t8} className={t9} mobileHeight={t10} onClose={t11} open={t12} showCloseButton={t13} iconClassName={t14} title={t15} titleClassName={t16}>{t27}</T0>;
    $[70] = T0;
    $[71] = t10;
    $[72] = t11;
    $[73] = t12;
    $[74] = t13;
    $[75] = t14;
    $[76] = t15;
    $[77] = t16;
    $[78] = t27;
    $[79] = t8;
    $[80] = t9;
    $[81] = t28;
  } else {
    t28 = $[81];
  }
  let t29;
  if ($[82] !== t17 || $[83] !== t18 || $[84] !== t28) {
    t29 = <>{t17}{t18}{t28}</>;
    $[82] = t17;
    $[83] = t18;
    $[84] = t28;
    $[85] = t29;
  } else {
    t29 = $[85];
  }
  return t29;
};